/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user-a-solid': {
    width: 16,
    height: 16,
    viewBox: '0 0 25 25',
    data: '<circle pid="0" cx="13" cy="3" r="3"/><path pid="1" d="M13 7a5 5 0 0 0-5 5v3.5A1.5 1.5 0 0 0 9.5 17h.5v5.5a1.5 1.5 0 0 0 1.5 1.5h3a1.5 1.5 0 0 0 1.5-1.5V17h.5a1.5 1.5 0 0 0 1.5-1.5V12a5 5 0 0 0-5-5z"/>'
  }
})
